import React from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"
import {PrimaryNavItem} from "../../models/primary-nav"

type BurgerPrimaryNavProps = {
    chevronIconAltText: string
    items: PrimaryNavItem[]
    showAsWideView: boolean
    textAlignment: string
    realm: string
    variant: string
    iconsVersionPath: string
    siteUrl: string
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const BurgerPrimaryNav = ({
    items,
    textAlignment,
    chevronIconAltText,
    showAsWideView,
    realm,
    variant,
    siteUrl,
    iconsVersionPath,
    templating,
}: BurgerPrimaryNavProps) => {
    const props = {
        items,
        textAlignment,
        chevronIconAltText,
        showAsWideView,
        realm,
        variant,
        siteUrl,
        iconsVersionPath,
    }
    const TemplatedBurgerPrimaryNav = useTemplatedComponent(templating, MANIFEST)

    return <TemplatedBurgerPrimaryNav {...props} />
}
export default connect(BurgerPrimaryNav)
